import { isNil } from 'ramda'
import { matchPath } from 'react-router-dom'

const matchSearchPath = (pathname: string) =>
  !isNil(matchPath(pathname, { path: '/search/:view?' }))

export default matchSearchPath
